var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{attrs:{"id":"iq3-application"}},[_c('annotation-feature'),_c('audio-conference-feature'),_c('kinematics-feature'),_c('on-boarding-tutorial-feature'),_c('training-feature'),_c('selection-feature'),_c('wait-for-confirmation'),_c('training-menu-display')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }